
import { ChevronDown, ChevronUp } from "lucide-react";
import { SubcategorySection } from "./SubcategorySection";

interface CategorySectionProps {
  measurementType: string;
  categories: Record<string, string[]>;
  isExpanded: boolean;
  expandedSubcategories: string[];
  onToggleCategory: () => void;
  onToggleSubcategory: (subcategory: string) => void;
}

export function CategorySection({
  measurementType,
  categories,
  isExpanded,
  expandedSubcategories,
  onToggleCategory,
  onToggleSubcategory,
}: CategorySectionProps) {
  return (
    <div className="relative mb-3 transform transition-all duration-300 hover:translate-y-[-2px]">
      <button
        onClick={onToggleCategory}
        className="w-full flex items-center justify-between p-4 
                   bg-gradient-to-r from-manuscript-primary/10 via-manuscript-primary/5 to-manuscript-primary/10
                   rounded-lg shadow-md border border-manuscript-primary/20 
                   hover:shadow-lg transition-all duration-300 group
                   relative overflow-hidden"
        aria-expanded={isExpanded}
      >
        <div className="absolute inset-0 bg-manuscript-secondary/5 opacity-0 
                      group-hover:opacity-100 transition-opacity duration-300"/>
        <div className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r 
                     from-manuscript-secondary via-manuscript-secondary/80 to-transparent 
                     transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"/>
        
        <h2 className="text-xl md:text-2xl font-cinzel text-manuscript-primary relative z-10 
                      group-hover:text-manuscript-primary/90 transition-colors duration-300">
          {measurementType}
        </h2>
        <span className="text-manuscript-primary/70 transition-all duration-300
                     transform group-hover:scale-110 group-hover:text-manuscript-primary">
          {isExpanded ? (
            <ChevronUp className="w-5 h-5 md:w-6 md:h-6" />
          ) : (
            <ChevronDown className="w-5 h-5 md:w-6 md:h-6" />
          )}
        </span>
      </button>

      {isExpanded && (
        <div className="mt-3 pl-4 relative animate-fade-in
                      before:content-[''] before:absolute before:left-2 before:top-0 
                      before:w-0.5 before:h-full before:bg-gradient-to-b 
                      before:from-manuscript-secondary/70 before:via-manuscript-secondary/40 before:to-transparent">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {Object.entries(categories).map(([subcategory, units], subIndex) => (
              <SubcategorySection
                key={subcategory}
                subcategory={subcategory}
                units={units}
                isExpanded={expandedSubcategories.includes(subcategory)}
                indentLevel={0}
                onToggle={() => onToggleSubcategory(subcategory)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
